
const state = {
  ImgFolderPath: null,    //图片虚拟文件夹路径
  NewsHost: null,         //新闻host
  WebSocketUrl: null,
  WebApiUrl: null
}

const getters = {
  ImgFolderPath(state) {
    return state.ImgFolderPath || sessionStorage.getItem("ImgFolderPath")
  },
  NewsHost(state) {
    return state.NewsHost || sessionStorage.getItem("NewsHost")
  },
  WebSocketUrl(state) {
    return state.WebSocketUrl || sessionStorage.getItem("WebSocketUrl")
  },
  WebApiUrl(state) {
    return state.WebApiUrl || sessionStorage.getItem("WebApiUrl")
  },  
}

const mutations = {
  SAVE_ImgFolderPath(state, value) {
    state.ImgFolderPath = value;
    sessionStorage.setItem("ImgFolderPath", value);
  },
  SAVE_NewsHost(state, value) {
    state.NewsHost = value;
    sessionStorage.setItem("NewsHost", value)
  },
  SAVE_WebSocketUrl(state, value) {
    state.WebSocketUrl = value;
    sessionStorage.setItem("WebSocketUrl", value)
  },
  SAVE_WebApiUrl(state, value) {
    state.WebApiUrl = value;
    sessionStorage.setItem("WebApiUrl", value)
  },  
}

const actions = {
  saveImgFolderPath(context, value) {
    context.commit('SAVE_ImgFolderPath', value)
  },
  saveNewsHost(context, value) {
    context.commit('SAVE_NewsHost', value)
  },
  saveWebSocketUrl(context, value) {
    context.commit('SAVE_WebSocketUrl', value)
  },
  saveWebApiUrl(context, value) {
    context.commit('SAVE_WebApiUrl', value)
  },  
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/js/store/modules/globalConfig.js